export function promisedTimeout(ms: number) {
  return new Promise((r) => setTimeout(r, ms))
}

export function stringEndsWith(str: string, suffix: string) {
  return str.indexOf(suffix, str.length - suffix.length) !== -1;
}

export function convertFormBuilderSexValueToFrontendValue(sexId: string|undefined|null) {
  if (sexId === "Male") {
    return "m"
  }
  else if (sexId === "Female") {
    return "f"
  }

  return "u"
}

export function convertFrontendSexValueToFormBuilderValue(sexId: string|undefined|null) {
  if (sexId === "m") {
    return "Male"
  }
  else if (sexId === "f") {
    return "Female"
  }

  return "Unknown"
}

export function escapeHtml(text: string): string {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

export function snakeToCamel(str: string): string {
  return str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
}

export function convertKeysToCamel<T>(input: T): T {
  if (Array.isArray(input)) {
    return input.map(item => convertKeysToCamel(item)) as unknown as T;
  }
  if (input !== null && typeof input === 'object') {
    const result: Record<string, any> = {};
    for (const key in input) {
      if (Object.prototype.hasOwnProperty.call(input, key)) {
        const camelKey = snakeToCamel(key);
        result[camelKey] = convertKeysToCamel((input as any)[key]);
      }
    }
    return result as T;
  }
  return input;
}
